import ApiService from '../services/ApiService';

export default class AuthRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    login(email, password) {
        return new Promise((resolve, reject) => {
            this.apiService
                .post('admin/login', {
                    email: email,
                    password: password
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}
